export enum HomeRouterNames {
  DASHBOARD = "dashboard",
  EMPLOYEES = "employees",
  ALL_CASES = "all_cases",
  REDUNDANCY_CALCULATOR = "redundancy-calculator",
  TASKS = "tasks",
  TIME_ATTENDANCE = "time-attendance",
  CALENDAR = "calendar",
  STORE_DETAILS = "store-details",
  REQUESTS = "requests",
  SCHEDULING = "scheduling",
  NOTIFICATION_LOGS = "notification-logs",
  CANDIDATES = "candidates",
  SYSTEM_USER = "system-user",
  SYSTEM_SETTING = "system-setting",
  ORGANISATION_SETUP = "organisation-setup",
  UPCOMING_NOTIFICATIONS = "notification-logs/upcoming-notifications",
  FLEET = "fleet",
  DAMAGE = "damage",
  INCIDENTS = "incidents",
  MetricsUpload = "metrics-upload",
  TeamScorecard = "teamscorecard",
  DriverScorecard = "driver-scorecard",
  DriverScorecardDetail = "driver-scorecard/:id",
  FLEET_INSPECTION_DETAIL = "fleet/inspection/:id",
  INCIDENT_DETAIL = "incidents/:id",
  FLEET_SETTINGS = "fleet/settings",
  FLEET_VEHICLES = "fleet/vehicles",
  FLEET_ALERTS = "fleet/alerts",
  FLEET_AI_INSIGHTS = "fleet/ai-insights",
  FLEET_MAINTENANCE = "fleet/maintenance",
  AUTO_ROSTER = "auto-roster",
  FLEET_HEALTH_REPORT = "fleet/health-report",
  FLEET_COACHING_TIPS = "fleet/coaching-tips",
  FLEET_ADMIN_NOTIFICATIONS = "admin-notification",
  FLEET_NOTIFICATION_POPUPS = "fleet/notification-popups",
  AUDIT_LOG = "audit-log",
  WORKFORCE = "workforce",
}
